import { useEffect, useState } from "react"
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts"
import { createNewCustomer } from "../../../apis/customers"
import { OtpSend, uploadFile, verifyAadharOtp } from "../../../apis/auth"
import { Link, useNavigate } from "react-router-dom"
import Select from "react-select"
import { validateField } from "./customer-form-validation"

const CustomerCreationWithAadhar = () => {
  const navigate = useNavigate()
  const initialValues = {
    full_name: "",
    email: "",
    fatherName: "",
    gender: "",
    martialStatus: "",
    phone_number: "",
    phone_number2: "",
    aadharNumber: "",
    PanNumber: "",
    company: "",
    dob: "",
    postal_code: "",
    street: "",
    geo_location: ""
  }
  const [formData, setFormData] = useState(initialValues)
  const [martialStatus, setMartialStatus] = useState()
  const [selectedOption, setSelectedOption] = useState()
  const [aadharNo, setAadharNo] = useState()
  const [aadharModal, setAadharModal] = useState(false)
  const [image, setImage] = useState(null)
  const [imageUrl, setImageUrl] = useState("")
  const [error, setError] = useState("")
  const [isOtpSent, setIsOtpSent] = useState(true)
  const [countdown, setCountdown] = useState(0)
  const [aadharRef, setAadharRef] = useState("")
  const [openOtp, setOpenOtp] = useState(false)
  const [otp, setOtp] = useState()
  const [errors, setErrors] = useState({})

  const handleSelect = option => {
    setSelectedOption(option || undefined)
  }

  useEffect(() => {
    if (!isOtpSent || countdown <= 0) return
    const timer = setInterval(() => {
      setCountdown(prev => prev - 1)
    }, 1000)
    return () => clearInterval(timer)
  }, [isOtpSent, countdown])

  const formatCountdown = seconds => {
    const minutes = String(Math.floor(seconds / 60)).padStart(2, "0")
    const secs = String(seconds % 60).padStart(2, "0")
    return `${minutes}:${secs}`
  }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }
  const {
    full_name,
    fatherName,
    email,
    phone_number,
    phone_number2,
    PanNumber,
    aadharNumber,
    dob,
    gender
  } = formData
  const addressState = {
    addressLine: "",
    city: "",
    state: "",
    country: "",
    pincode: ""
  }
  const permanentaddressState = {
    addressLine1: "",
    city1: "",
    state1: "",
    country1: "",
    pincode1: ""
  }

  const [address, setAddress] = useState(addressState)
  const { city, state, country, pincode, addressLine } = address
  const [permanentaddress, setPermanentAddress] = useState(
    permanentaddressState
  )
  const { city1, state1, country1, pincode1, addressLine1 } = permanentaddress
  const [selectCheck, setSelectCheck] = useState(false)
  useEffect(() => {
    if (selectCheck) {
      setPermanentAddress({
        addressLine1: address?.addressLine,
        city1: address?.city,
        state1: address?.state,
        country1: address?.country,
        pincode1: address?.pincode
      })
    } else {
      setPermanentAddress({
        addressLine1: "",
        city1: "",
        state1: "",
        country1: "",
        pincode1: ""
      })
    }
  }, [selectCheck])

  const handleAddressChange = e => {
    const { name, value } = e.target
    setAddress({ ...address, [name]: value })
  }
  const handlePermaAddressChange = e => {
    const { name, value } = e.target
    setPermanentAddress({ ...permanentaddress, [name]: value })
  }
  const mtIdString = sessionStorage.getItem("info")
  let mtId = null

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString)
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error)
    }
  }
  const customerInformation = JSON.parse(sessionStorage.getItem("info"))

  const Gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" }
  ]
  const martial = [
    { value: "single", label: "Single" },
    { value: "married", label: "Married" },
    { value: "widowed", label: "Widowed" },
    { value: "divorced", label: "Divorced" }
  ]
  const handleMartialSelect = option => {
    setMartialStatus(option || undefined)
  }

  const handleFileChange = async e => {
    const file = e.target.files?.[0]
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB")
        setImage(null)
        return
      }
      setError("")
      setImage(file)
      const formData = new FormData()
      formData.append("image", file)
      const response = await uploadFile(formData)
      if (response.status === true) {
        setImageUrl(response.data.image)
      }
    }
  }

  const handleCancel = () => {
    setImage(null)
    setError("")
  }

  const handleFormValidation = (form) => {
    const newErrors = {};
    Array.from(form.elements).forEach((element) => {
      if (element.name) {

        const error = validateField(element.name, element.value);
        if (error) {
          newErrors[element.name] = error;
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };

  const handleSubmit = async event => {
    event.preventDefault()
    const isValid = handleFormValidation(event.target);
    if (!isValid) {
      errorAlert(
        "Please fix the errors before submitting."
      )
      return
    }
    const requiredFields = [
      "email",
      "full_name",
      "fatherName",
      "phone_number",
      "PanNumber",
      "dob",
      "aadharNumber"
    ]

    const emptyFields = requiredFields.filter(field => !formData[field]?.trim())

    if (emptyFields.length > 0) {
      console.error(`The following fields are empty: ${emptyFields.join(", ")}`)
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      )
      return
    }

    const master_Id = mtId?.id || "0"
    const type = mtId?.type || "0"

    const payload = {
      email: formData.email,
      full_name: formData.full_name,
      fatherName: formData.fatherName,
      martialStatus: martialStatus.value,
      gender: formData.gender,
      phoneNumber1: formData.phone_number,
      phoneNumber2: formData.phone_number2,
      dob: formData.dob,
      PanNumber: formData.PanNumber,
      aadharNumber: formData.aadharNumber,
      current_address: permanentaddress,
      address: address,
      user_name: "",
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      user_id: master_Id,
      cust_type: customerInformation.type,
      type: type,
      retailer_id: type === "retailer" ? mtId.id : null
    }

    try {
      const response = await createNewCustomer(payload)
      if (response.status === true) {
        successAlert("Success", "Loan Successfully Created")
        setImage(null)
        setFormData(initialValues)
        setAddress(addressState)
        setPermanentAddress(permanentaddressState)
        setSelectCheck(false)
        navigate("/customers")
      }
    } catch (error) { }
  }

  const sendAadharOtp = async e => {
    e.preventDefault()
    const payload = {
      aadharNumber: aadharNo
    }
    const response = await OtpSend(payload)
    setAadharRef(response.data.reference_id)
    setOpenOtp(true)
    setCountdown(300)
  }

  const reSendAadharOtp = async e => {
    e.preventDefault()
    const payload = {
      aadharNumber: aadharNo
    }
    const response = await OtpSend(payload)
    setOpenOtp(true)
    alert("OTP is resent successfully!")
  }

  const formatDob = dobString => {
    const [day, month, year] = dobString.split("-")
    return `${year}-${month}-${day}`
  }

  const verifyAadhar = async e => {
    e.preventDefault()
    const payload = {
      aadharNumber: aadharNo,
      otp: otp,
      ref_id: aadharRef
    }
    const response = await verifyAadharOtp(payload)
    const { data } = response
    setFormData({
      ...formData,
      full_name: data.name,
      dob: formatDob(data.date_of_birth),
      aadharNumber: aadharNo,
      PanNumber: data.pan_number,
      fatherName: data.care_of,
      gender: data.gender,
      martialStatus: ""
    })
    setAddress(prev => ({
      ...prev,
      addressLine: `${data.address.house}, ${data.address.street}, ${data.address.post_office}`,
      city: data.address.district,
      state: data.address.state,
      country: data.address.country,
      pincode: data.address.pincode
    }))
    setOpenOtp(false)
    setAadharModal(true)
  }

  return (
    <>
      <div className="page-wrapper">
        {aadharModal && (
          <div className="content">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <form onSubmit={handleSubmit}>
                  <div className="contact-grids-tab">
                    <ul className="nav nav-underline" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="info-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#basic-info"
                          type="button"
                          role="tab"
                          aria-selected="true"
                        >
                          Basic Information
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="basic-info"
                      role="tabpanel"
                      aria-labelledby="info-tab"
                      tabIndex={0}
                    >
                      <div className="modal-body pb-0 ">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                                <i className="ti ti-photo text-gray-2 fs-16" />
                              </div>

                              <div className="profile-upload">
                                <div className="mb-2">
                                  <h6 className="mb-1">Upload Profile Image</h6>
                                  <p className="fs-12">
                                    Image should be below 4 MB
                                  </p>
                                  {error && (
                                    <p className="text-danger">{error}</p>
                                  )}
                                  {errors["profile_pic"] && (
                                    <p className="text-danger">
                                      {errors["profile_pic"]}
                                    </p>
                                  )}
                                </div>
                                <div className="profile-uploader d-flex align-items-center">
                                  <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                    Upload
                                    <input
                                      name="profile_pic"
                                      type="file"
                                      className="form-control image-sign"
                                      accept="image/*"
                                      onChange={handleFileChange}
                                    />
                                  </div>
                                  <Link
                                    to="#"
                                    className="btn btn-light btn-sm"
                                    onClick={handleCancel}
                                  >
                                    Cancel
                                  </Link>
                                </div>
                                {image && (
                                  <div className="mt-3">
                                    <p>Preview:</p>
                                    <img
                                      src={URL.createObjectURL(image)}
                                      alt="Profile Preview"
                                      className="img-thumbnail"
                                      style={{
                                        maxWidth: "150px",
                                        maxHeight: "150px"
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Full Name{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="full_name"
                                value={full_name}
                                onChange={handleChange}
                                className="form-control"
                                disabled
                              />
                              {errors["full_name"] && (
                                <p className="text-danger">
                                  {errors["full_name"]}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Phone Number{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="number"
                                name="phone_number"
                                value={phone_number}
                                maxLength={10}
                                minLength={10}
                                onChange={handleChange}
                                className="form-control"
                              />
                              {errors["phone_number"] && (
                                <p className="text-danger">
                                  {errors["phone_number"]}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Alternate Phone Number{" "}
                              </label>
                              <input
                                type="number"
                                name="phone_number2"
                                value={phone_number2}
                                maxLength={10}
                                minLength={10}
                                onChange={handleChange}
                                className="form-control"
                              />
                              {errors["phone_number2"] && (
                                <p className="text-danger">
                                  {errors["phone_number2"]}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Email <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={handleChange}
                                className="form-control"
                              />
                              {errors["email"] && (
                                <p className="text-danger">{errors["email"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Date of Birth{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="date"
                                name="dob"
                                value={dob}
                                onChange={handleChange}
                                className="form-control"
                                disabled
                              />
                              {errors["dob"] && (
                                <p className="text-danger">{errors["dob"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Aadhar Number{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="number"
                                name="aadharNumber"
                                value={aadharNumber}
                                onChange={handleChange}
                                minLength={12}
                                maxLength={12}
                                disabled
                                className="form-control"
                              />
                              {errors["aadharNumber"] && (
                                <p className="text-danger">
                                  {errors["aadharNumber"]}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Pan Number{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="PanNumber"
                                value={PanNumber}
                                onChange={handleChange}
                                className="form-control"
                              />
                              {errors["PanNumber"] && (
                                <p className="text-danger">
                                  {errors["PanNumber"]}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Father/Husband Name{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="fatherName"
                                value={fatherName}
                                onChange={handleChange}
                                className="form-control"
                                disabled
                              />
                              {errors["fatherName"] && (
                                <p className="text-danger">
                                  {errors["fatherName"]}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Gender <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="gender"
                                value={
                                  gender === "M"
                                    ? "male"
                                    : gender === "F"
                                      ? "female"
                                      : "other"
                                }
                                onChange={handleChange}
                                className="form-control"
                                disabled
                              />
                              {errors["gender"] && (
                                <p className="text-danger">{errors["gender"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                {" "}
                                Martial Status
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                className="select"
                                options={martial}
                                name="martialStatus"
                                value={martialStatus}
                                onChange={handleMartialSelect}
                                placeholder="--Select--"
                              />
                              {errors["martialStatus"] && (
                                <p className="text-danger">{errors["martialStatus"]}</p>
                              )}
                            </div>
                          </div>

                          <div className="">
                            <label className="form-label">
                              Permanent Address
                            </label>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Address Line{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="addressLine"
                                value={addressLine}
                                onChange={handleAddressChange}
                                className="form-control"
                              />{errors["addressLine"] && (
                                <p className="text-danger">{errors["addressLine"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                City <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="city"
                                value={city}
                                onChange={handleAddressChange}
                                className="form-control"
                              />
                              {errors["city"] && (
                                <p className="text-danger">{errors["city"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                State <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="state"
                                value={state}
                                onChange={handleAddressChange}
                                className="form-control"
                              />
                              {errors["state"] && (
                                <p className="text-danger">{errors["state"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Country <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="country"
                                value={country}
                                onChange={handleAddressChange}
                                className="form-control"
                              />
                              {errors["country"] && (
                                <p className="text-danger">{errors["country"]}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                PinCode <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="pincode"
                                value={pincode}
                                onChange={handleAddressChange}
                                className="form-control"
                              />
                              {errors["pincode"] && (
                                <p className="text-danger">{errors["pincode"]}</p>
                              )}
                            </div>
                          </div>

                          <div
                            className=" d-flex align-items-baseline"
                            style={{ gap: "20px" }}
                          >
                            <input
                              type="checkbox"
                              onChange={() => setSelectCheck(!selectCheck)}
                            />
                            <label className="form-label">
                              Current Address is same as Permanent Address
                            </label>
                          </div>
                          {!selectCheck && (
                            <>
                              <div className="">
                                <label className="form-label">
                                  Current Address
                                </label>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Address Line{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="addressLine1"
                                    value={addressLine1}
                                    onChange={handlePermaAddressChange}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    City <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="city1"
                                    value={city1}
                                    onChange={handlePermaAddressChange}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    State{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="state1"
                                    value={state1}
                                    onChange={handlePermaAddressChange}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Country{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="country1"
                                    value={country1}
                                    onChange={handlePermaAddressChange}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="mb-3">
                                  <label className="form-label">
                                    PinCode{" "}
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="pincode1"
                                    value={pincode1}
                                    onChange={handlePermaAddressChange}
                                    className="form-control"
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          data-bs-dismiss="modal"
                          className="btn btn-primary"
                        >
                          Submit{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {!aadharModal && (
          <div className="card" style={{ minHeight: "70vh" }}>
            <div className="d-flex justify-content-center">
              <form>
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 mt-20">
                    <div className="row">
                      <div className="">
                        <div className="mb-3">
                          <label className="form-label">
                            Aadhar Number{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            value={aadharNo}
                            maxLength={12}
                            onChange={e => setAadharNo(e.target.value)}
                            className="form-control"
                          />
                        </div>
                      </div>
                      {openOtp && (
                        <div className="">
                          <div className="mb-3">
                            <label className="form-label">
                              Aadhar Otp
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              value={otp}
                              onChange={e => setOtp(e.target.value)}
                              className="form-control"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    {!openOtp ? (
                      <button
                        type="submit"
                        onClick={sendAadharOtp}
                        className="btn btn-primary"
                      >
                        Send Otp
                      </button>
                    ) : (
                      <div>
                        {countdown > 0 ? (
                          <span className="text-muted me-3">
                            Resend available in {formatCountdown(countdown)}
                          </span>
                        ) : (
                          <button
                            type="submit"
                            onClick={reSendAadharOtp}
                            className="btn btn-primary me-2"
                          >
                            Resend OTP
                          </button>
                        )}
                        <button
                          type="submit"
                          onClick={verifyAadhar}
                          className="btn btn-primary"
                        >
                          Verify Otp
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default CustomerCreationWithAadhar
